module.exports = __webpack_public_path__ + "img/gsndc2762_2.c87451ff.svg";